<div class="header" [style.z-index]="999">
    <div class="hotel_logo"></div>
    <div class="today_info">
        <!-- calendar area-->
        <div class="clock">
            <div class="date">
                <div class="year">{{ now_date_obj.year }}.</div>
                <div class="month-date">{{ now_date_obj.month }}. {{ now_date_obj.day }}</div>
                <div class="week">({{ now_date_obj.day_of_week }})</div>
            </div>
            <div class="time">
                {{ now_date_obj.hhmm }}
            </div>
        </div>
        <!-- weather -->
        <div class="weather" [ngClass]="{'weather_eng': isEng}">
            <div class="weather_today">
                <span *ngIf="!isEng"> 本日のお天気</span>
                <span *ngIf="isEng"> Today:</span>
                <canvas width="50" height="50" id="today"></canvas>
                <span class="rainy">{{ today_rainy }}</span>
                <span class="temp">
                    {{ today_temp }}
                </span>

            </div>
            <div class="weather_tomorrow">

                <span *ngIf="!isEng"> 明日のお天気</span>
                <span *ngIf="isEng"> Tomorrow:</span>

                <canvas width="50" height="50" id="tomorrow"></canvas>
                <span class="rainy">{{ tommorow_rainy }}</span>
                <span class="temp">
                    {{ tommorow_temp }}
                </span>

            </div>

        </div>
    </div>
</div>

<!-- main -->

<div class="main">
    <div id="particles-js"></div>

    <div class="icon_container">
        <ng-container *ngFor="let item of icons; let i = index">

            <div (click)="aClick(i)" (blur)="blur(i)" (focus)="changeIcon(i)" class="icon_btn">
                <div class="icon_name">
                    <p *ngIf="!isEng">{{item.jpn}}</p>
                    <p *ngIf="isEng">{{item.eng}}</p>
                </div>
                <img [src]="item.icon" class="icon_img" />


            </div>
        </ng-container>
    </div>

    <a class="hmj_movie" *ngIf="fullVideoSrc" (click)="PlayVideo()"> </a>

</div>

<!-- banner-->
<a [routerLink]="['/info']" [queryParams]="{ page: '1'}" class="cluboriental">
    <img src="/assets/top-image/banner.png" *ngIf="!isEng">
    <img src="/assets/top-image/banner_en.png" *ngIf="isEng">
</a>
<!-- popup-->
<div class="popup_box">
    <div *ngIf="!isEng">
        <p>News!!</p>
        <p>レンタサイクル申し込み時にホテルメンバーシップに新規入会いただくと初回1日利用無料</p>

    </div>
    <div *ngIf="isEng" class="popup_eng">
        <p> News!</p>
        <p>If you join the hotel membership program when you apply for a rental bike, you can use it for free for the
            first day.</p>

    </div>
</div>

<!-- wifi-->
<div class="wifi-info">
    <img src="/assets/icons/com/wifi_icon.svg" alt="wifi" class="wifi_icon">
    <dl>
        <dt>SSID</dt>
        <dd>{{ ssid }}</dd>
        <dt>KEY</dt>
        <dd>
            {{ password }}
        </dd>
    </dl>

    <div class="qr_code">
        <qrcode [qrdata]="qr" [width]="80"></qrcode>
    </div>

</div>



<!-- footer -->
<div class="footer">

    <div *ngIf="!isEng" class="room_info">

        <p> こちらのお部屋は</p>
        <div class="room_number">{{ room_no }}</div>
        <p>号室です</p>
    </div>
    <div *ngIf="isEng" class="room_info room_info_eng">

        <p class="room_info_text"> This room is</p>
        <div class="room_number">{{ room_no }}</div>

    </div>
</div>


<img src="/assets/top-image/license.png" class="license">

<div [@ActiveMovie]="Video ? 'active': 'inactive'" class="video_wrapper" [hidden]="!Video">
    <video width="1920" height="1080" #myVideo [muted]="false" [src]="fullVideoSrc" type="video/webm"
        (ended)="closeVideo()"></video>
</div>